import { HouseSelectItem } from '../../../components/HouseSelectItem';
import { IHouse } from '../../../types/newbuilding/house';

export function prepareItems(houses: IHouse[], isReliableJK: boolean) {
  const allHousesFlatsCounter = houses.reduce((acc, value) => {
    return acc + (value.fromDeveloperPropsCount as number);
  }, 0);

  return [
    {
      id: undefined,
      key: 'all',
      node: <HouseSelectItem title="Все корпуса" value={allHousesFlatsCounter} isReliable={isReliableJK} />,
    },
    ...houses.map(({ houseId, houseName, finishStatus, fromDeveloperPropsCount, isReliable, isSalesStart }) => ({
      id: houseId,
      node: (
        <HouseSelectItem
          title={houseName}
          subtitle={finishStatus}
          value={fromDeveloperPropsCount}
          isReliable={isReliable}
          isSalesStart={isSalesStart}
        />
      ),
    })),
  ];
}
